var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5127 5.06536L20.7656 0.469401C20.4519 0.168767 20.0274 0 19.5849 0C19.1424 0 18.7179 0.168767 18.4042 0.469401L1.57499 16.6565L0.0384515 23.0441C-0.014554 23.2776 -0.0127369 23.5196 0.0437698 23.7523C0.100277 23.9851 0.210046 24.2027 0.365058 24.3893C0.520071 24.576 0.716411 24.7269 0.939735 24.8311C1.16306 24.9353 1.40773 24.9901 1.65586 24.9916C1.77148 25.0028 1.88799 25.0028 2.00361 24.9916L8.70778 23.5115L25.5127 7.33997C25.8248 7.03781 26 6.6289 26 6.20266C26 5.77642 25.8248 5.36752 25.5127 5.06536ZM7.89907 22.1094L1.61543 23.3791L3.04684 17.4433L15.6384 5.36137L20.4906 10.0352L7.89907 22.1094ZM21.5743 8.90571L16.7221 4.23185L19.5363 1.5366L24.3077 6.21045L21.5743 8.90571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.f83a4d59152a4afd17e449affb4f6c47.svg";
export { ForwardRef as ReactComponent };